import React, { useState } from "react";
import "./IndiaSec1.css";
import { map } from "lodash";

export const IndiaSec1 = ({ IndiaSec1Data }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  // Pehla paragraph aur target word break point
  let firstParagraph = IndiaSec1Data?.text?.[0] || "";
  const targetWord = "traveler.";
  
  // Array ka baki ka content (agar 1 se zyada paragraphs ho)
  const remainingParagraphs = IndiaSec1Data?.text?.slice(1) || [];

  // Logic: "traveler." word ke base par pehle paragraph ko split karna
  let visibleText = firstParagraph;
  let hiddenTextOfFirstPara = "";

if (typeof firstParagraph === "string" && firstParagraph.includes(targetWord)) {
  const splitIndex =
    firstParagraph.indexOf(targetWord) + targetWord.length;

  visibleText = firstParagraph.slice(0, splitIndex);
  hiddenTextOfFirstPara = firstParagraph.slice(splitIndex);
}
  return (
    <div className="introduction standard-padding">
      <div className="Extramargin">
        <p className="subheading IndiaSectitle">{IndiaSec1Data?.title}</p>
        <h1 className="heading IndiaSechead">
          {IndiaSec1Data?.head
            ?.toLowerCase()
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")
            .replace(/\bUae\b/g, "UAE")}
        </h1>

        {/* 1st Paragraph with Break Point */}
        <p className="text">
          {visibleText}
          
          {/* Expanded State: 1st Para ka baki text */}
          {isExpanded && hiddenTextOfFirstPara}

          {/* Collapsed State: Read More Button right after "traveler." */}
          {!isExpanded && (
            <button
              type="button"
              className="read-more-btn"
              onClick={toggleReadMore}
            >
              {" "}Read More...
            </button>
          )}
        </p>

        {/* Expanded State: Baki ke saare paragraphs (Index 1 and onwards) */}
        {isExpanded && (
          <>
            {map(remainingParagraphs, (text, index) => (
              <p key={index + 1} className="text">
                {text}
              </p>
            ))}

            {/* Read Less Button at the Very End */}
            <button
              type="button"
              className="read-more-btn read-less-btn"
              onClick={toggleReadMore}
            >
              Read Less
            </button>
          </>
        )}
      </div>
    </div>
  );
};